import { formatCategory, toLowerWithDashes } from '../util';
import { useConfig } from "../contexts/ConfigContext";
import { useAppState } from "../contexts/AppStateContext";

const MenuButton = ({ 
    shortcodeData: { shortcodeAtts },
}) => {
    // Get static config from ConfigContext
    const {
        retailers,
        nonHeadlessRetailers,
    } = useConfig();
    
    // Get dynamic state from AppStateContext
    const {
        retailerId,
        nonHeadlessRetailer,
        nonHeadlessRetailerData,
    } = useAppState();
    
    const retailerConfig = retailers[retailerId];
    
    const buttonClass = shortcodeAtts.buttonClass || 'headless-button';
    const buttonTitle = shortcodeAtts.title || 'Shop Now';
    
    const currentNonHeadlessRetailer = nonHeadlessRetailer;
    const isNonHeadlessRetailer = !!currentNonHeadlessRetailer;
    
    const getCurrentRetailer = () => {
        if (isNonHeadlessRetailer) {
            // Use the already stored nonHeadlessRetailerData from AppStateContext
            return nonHeadlessRetailerData || null;
        }
        return retailers[retailerId] || null;
    };

    const currentRetailer = getCurrentRetailer();
    
    let menuLink = retailerConfig?.menuSlug;
    
    if (isNonHeadlessRetailer && currentRetailer?.menu_page) {
        menuLink = currentRetailer.menu_page;
    }
    
    if (shortcodeAtts.specials && !isNonHeadlessRetailer) {
        menuLink = '/shop/' + menuLink + '/specials/';
    } else if (shortcodeAtts.category && !isNonHeadlessRetailer) {
        menuLink =
            '/shop/' +
            menuLink +
            '/category/' +
            formatCategory(shortcodeAtts.category).toLowerCase();
    } else if (shortcodeAtts.brand && !isNonHeadlessRetailer) {
        menuLink =
            '/shop/' + menuLink + '/brand/' + toLowerWithDashes(shortcodeAtts.brand);
    } else if (!isNonHeadlessRetailer) {
        menuLink = '/shop/' + menuLink;
    }

    return menuLink ? (
        <a className={buttonClass} href={`${menuLink}`}>
            {buttonTitle}
        </a>
    ) : null;
};

export default MenuButton;
